module.exports = __webpack_public_path__ + "static/reservoir-zoom-9fbb02880343849162bb716f14eed80f.jpg";